module.exports = "/assets/mobile-apps/android-app.png?5aWewKt";